import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ArrowLeftIcon = createIcon({
  displayName: 'ArrowLeftIcon',
  path: [
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M10.25 6.75L4.75 12L10.25 17.25'
    />,
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M19.25 12H5'
    />
  ],
  defaultProps: defaultProps
})
